// Deep-link target for notification taps (the push carries url = /chats/{id}).
// The push points at the chat, never at what a message inside it links to: the
// window marks the chat read before anyone moves on, and a notification aimed
// straight at the target would leave everything unread.

import { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useModal } from '../components/ModalProvider';
import ChatsModalBody from '../components/ChatsModalBody';

export default function PageChats() {
  const { chatId } = useParams();
  const { openModal } = useModal();
  const navigate = useNavigate();
  const openedRef = useRef(false);

  useEffect(() => {
    // No cancelling cleanup: StrictMode's second run would otherwise find the
    // flag set while the first one cancelled itself
    if (openedRef.current) return;
    openedRef.current = true;

    openModal({
      header: 'Chats',
      body: <ChatsModalBody initialChatId={chatId ?? null} />,
    });
    // Land under the window on the home page — closing it leaves somewhere to be
    navigate('/', { replace: true });
  }, [chatId, openModal, navigate]);

  return null;
}
